import { Routes } from '@angular/router';

export const AUTH_ROUTES: Routes = [
   {
    path: 'auth',
    loadChildren: './modules/auth/auth.module#AuthModule'
  },
 
];



// WEBPACK FOOTER //
// ./src/app/shared/routes/auth-layout.routes.ts